import type { ReactNode } from 'react'
import { label as labelStyle, input as inputStyle } from './styles'

interface FormFieldProps {
  readonly name: string
  readonly label: string
  readonly required?: boolean
  readonly children?: ReactNode
  readonly type?: string
  readonly value?: string
  readonly onChange?: (value: string) => void
  readonly placeholder?: string
  readonly disabled?: boolean
  readonly multiline?: boolean
  readonly rows?: number
}

export function FormField({
  name,
  label: labelText,
  required,
  children,
  type = 'text',
  value,
  onChange,
  placeholder,
  disabled,
  multiline = false,
  rows = 3,
}: FormFieldProps) {
  return (
    <div>
      <label htmlFor={name} style={labelStyle}>
        {labelText}
        {required && ' *'}
      </label>
      {children ??
        (multiline ? (
          <textarea
            id={name}
            name={name}
            style={{ ...inputStyle, resize: 'vertical' as const }}
            value={value ?? ''}
            onChange={onChange ? (e) => onChange(e.target.value) : undefined}
            placeholder={placeholder}
            disabled={disabled}
            rows={rows}
          />
        ) : (
          <input
            id={name}
            name={name}
            type={type}
            style={inputStyle}
            value={value ?? ''}
            onChange={onChange ? (e) => onChange(e.target.value) : undefined}
            placeholder={placeholder}
            disabled={disabled}
          />
        ))}
    </div>
  )
}
